import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import hook
import logo from '../Images/logo.png';
import '../styles/LandingPage.css';
import { FiSettings, FiUsers, FiBriefcase } from "react-icons/fi"; // Feather Icons (clean & modern)


const LandingPage = () => {
  const navigate = useNavigate(); // Get navigate function

  return (
    <div className="landing-container">
      <header className="header">
        <div className="logo-container">
          <div className="logo">
            <img src={logo} alt="PUMO TECHNOVATION" />
          </div>
          <h1 className="company-name">PumoTechnovation CRM</h1>
        </div>
        <div
          className="logout-button"
          onClick={() => {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            localStorage.removeItem("emp_name");
            localStorage.removeItem("placementFilterState");
            localStorage.removeItem("placementDbFilters");
            localStorage.removeItem("placedStudentFilters");
            localStorage.removeItem("jobDashboardFilters");
            localStorage.removeItem("jobDashboard-selectedColumns");
            sessionStorage.removeItem("lastActiveTab");
            sessionStorage.removeItem("lastJobReqPath");
            navigate('/'); // Redirect to login or home
          }}
        >
          Logout
        </div>


      </header>

      <main className="main-content">
        <div className="navigation-boxes">
          <div
            className="nav-box admin-box"
            onClick={() => navigate('/dashboard')} // ✅ Direct navigation
          >
            <div className="nav1-icon"> <FiSettings /></div>
            <h2>Admin Page</h2>
            <p>Administrative controls and system settings</p>
          </div>
          <div
            className="nav-box staff-box"
            onClick={() => navigate('/staff-dashboard')} // ✅ Direct navigation
          >
            <div className="nav1-icon">  <FiUsers /></div>
            <h2>Staff Page</h2>
            <p>Access staff dashboard and management tools</p>
          </div>
          <div
            className="nav-box staff-box"
            onClick={() => navigate('/Placementdb')} // ✅ Direct navigation
          >
            <div className="nav1-icon">  <FiBriefcase /></div>
            <h2>Placement Page</h2>
            <p>Access placement dashboard and management tools</p>
          </div>

        </div>
      </main>
    </div>
  );
};

export default LandingPage;
